import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/DataCard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '大数据可视化平台' // 定义标题
    },
    component: Home
  },
  {
    path: '/site',
    name: 'About',
    component: () => import('../views/siteDate.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
